export const RRWEB_ERROR_MESSAGE = {
  upload_error: '录制失败',
  report_error: '上报失败',
};

export const RRWEB_RECORD_STATE = {
  init: 1,
  recording: 2,
  done: 3,
};

export const RRWEB_RECORD_MODE = {
  action: 1,
  error: 2,
};

// 上报阀值，超过这个限制则自动上报一次
export const RRWEB_RESIZE_SIZE_LIMIT = 40 * 1024;

// 最大录制时长
export const MAX_RECORD_LIMIT = 3 * 60;
